import React, { Component } from 'react';
import ResearchItem from './ResearchItem.js';
import SmallResearchItem from './SmallResearchItem';

import AnimateHeight from 'react-animate-height';

class ResearchField extends Component {

    state = {
        "expanded": false,
        "smallResearchHeight": '0'
    }

    expand = () => {
        this.setState({expanded: !(this.state.expanded)})
        if (this.state.expanded) {
            this.setState({smallResearchHeight: '0'})
        } else {
            this.setState({smallResearchHeight: 'auto'})
        }
    }

    render() {

        const { smallResearchHeight } = this.state;

        return ( 
            <React.Fragment>
                <div style={staticStyle}>
                {this.props.research.map((res) => {
                    if ( res.text !== "") {
                        return (
                            <ResearchItem research={res} />
                        );
                    }
                })}
                </div>
                <AnimateHeight id='smallResearch' duration={1000} height={smallResearchHeight}>
                    {this.props.research.map((res) => {
                        if ( res.text === "") {
                            return (
                                <SmallResearchItem research={res} />
                            );
                        } 
                    })} 
                </AnimateHeight>
            </React.Fragment>
        );
    }
}

const staticStyle = {
    height: 'auto'
}

export default ResearchField;